import { useCallback, useState } from 'react';

import { AppointmentModalData } from '../../data/data/types';
import { SlotType } from '../../data/types/api/graphql';

const useAppointmentModal = () => {
  const [appointmentModalData, setAppointmentModalData] = useState<{
    slotType: SlotType;
    value: AppointmentModalData | null;
  }>({ slotType: SlotType.Common, value: null });

  const showAppointmentModal = useCallback(
    (slotType: SlotType, value: AppointmentModalData | null) => {
      const val = value
        ? {
            onClose: () => {
              setAppointmentModalData({
                slotType: SlotType.Common,
                value: null,
              });
            },
            ...value,
          }
        : null;

      setAppointmentModalData({ slotType, value: val });
    },
    []
  );
  return { appointmentModalData, showAppointmentModal };
};
export { useAppointmentModal };
